import { logError } from "./log-error";
import { serverRoutes } from "./server-routes";

import type { TCatalogueItem, TInventoryItem } from "./types";

function enrichCohortsWithProgramData(
  programs: Array<TCatalogueItem>,
): Array<TCatalogueItem> {
  return programs.map((program) => ({
    ...program,
    cohorts: (program.cohorts ?? []).map(
      (cohort) =>
        ({
          ...cohort,
          catalogueItem: {
            _id: program._id,
            name: program.name,
            type: program.type,
          },
        }) as TInventoryItem,
    ),
  }));
}

/**
 * @param {string} catalogueIds - A string with comma separated ids
 */
export async function getInventoryItemsGroupedByCatalogueItems(
  catalogueIds: string,
) {
  const SANITIZED_IDS = catalogueIds.replace(/ /g, "").split(",").toString();

  const BASE = process.env["NEXT_PUBLIC_HALL_OF_RECORDS_URI"] as string;

  const PARTNER_ID = process.env[
    "NEXT_PUBLIC_HALL_OF_RECORDS_PARTNER_ID"
  ] as string;

  const url =
    BASE +
    serverRoutes.availableCohorts.searchByCatalogueIds(
      PARTNER_ID,
      SANITIZED_IDS,
    );

  try {
    const response = await fetch(url);
    if (response.ok) {
      const json = await response.json();
      return json.data as Array<TCatalogueItem>;
    } else {
      return [];
    }
  } catch (e) {
    logError({
      action: "GALAXY_API_FETCH_INVENTORY",
      error: e,
      context: { catalogueIds },
    });
    return [];
  }
}

let _allItems: Array<TCatalogueItem> = [];
export async function getAllInventoryItems() {
  if (_allItems.length) {
    return _allItems;
  }

  const BASE = process.env["NEXT_PUBLIC_HALL_OF_RECORDS_URI"] as string;

  const PARTNER_ID = process.env[
    "NEXT_PUBLIC_HALL_OF_RECORDS_PARTNER_ID"
  ] as string;

  const url = `${BASE}${serverRoutes.availableCohorts.all(PARTNER_ID)}`;

  const response = await fetch(url);
  const json = await response.json();
  _allItems = enrichCohortsWithProgramData(
    (json?.data?.programs ?? []) as Array<TCatalogueItem>,
  );
  return _allItems;
}
